export default "__VITE_ASSET__568e11c7__"